(() => {
  if (window.ringCardMaterialSwitch) return;
  window.ringCardMaterialSwitch = true;
  const requests = new Map();
  const selections = new WeakMap();
  const galleries = new WeakMap();
  function setupGallery(card) {
    if (!window.matchMedia('(max-width: 768px)').matches) return;
    const link = card.querySelector('.product-card__image-link');
    const media = card.querySelector('.product-card__media');
    if (!link || !media) return;
    const images = [...link.querySelectorAll('img')];
    const old = galleries.get(card);
    if (old && old.images[0] === images[0]) return;
    media.querySelectorAll('.product-card__gallery-controls').forEach(el => el.remove());
    const state = { images, index: 0 };
    galleries.set(card, state);
    card.classList.add('has-card-gallery');
    const controls = document.createElement('div');
    controls.className = 'product-card__gallery-controls';
    const show = index => {
      state.index = (index + state.images.length) % state.images.length;
      state.images.forEach((image, i) => {
        if (i === state.index && image.dataset.src) {
          image.src = image.dataset.src;
          if (image.dataset.srcset) image.srcset = image.dataset.srcset;
          delete image.dataset.src;
          delete image.dataset.srcset;
        }
        image.classList.toggle('is-current', i === state.index);
        image.setAttribute('aria-hidden', String(i !== state.index));
      });
      controls.querySelectorAll('[data-slide]').forEach((dot, i) => {
        dot.setAttribute('aria-pressed', String(i === state.index));
      });
    };
    const dots = document.createElement('div');
    dots.className = 'product-card__gallery-dots';
    function renderDots() {
      dots.replaceChildren(...state.images.map((_, i) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.dataset.slide = i;
        dot.setAttribute('aria-label', `View image ${i + 1}`);
        return dot;
      }));
      controls.hidden = state.images.length < 2;
    }
    controls.append(dots);
    renderDots();
    media.append(controls);
    show(0);
    let loading;
    async function move(index) {
      // Load the full gallery only when the customer interacts with this card.
      if (!state.loaded) {
        loading ||= (async () => {
          const endpoint = new URL(link.href).pathname.replace(/\/$/, '') + '.js';
          if (!requests.has(endpoint)) requests.set(endpoint, fetch(endpoint)
            .then(r => { if (!r.ok) throw new Error('Gallery unavailable'); return r.json(); })
            .catch(error => { requests.delete(endpoint); throw error; }));
          const product = await requests.get(endpoint);
          if (galleries.get(card) !== state) return;
          if (product.images?.length) {
            state.images = product.images.map(source => {
              const img = document.createElement('img');
              img.className = 'product-card__img';
              const src = typeof source === 'string' ? source : source.src;
              img.dataset.src = src + (src.includes('?') ? '&' : '?') + 'width=640';
              img.alt = product.title;
              img.decoding = 'async';
              return img;
            });
            link.replaceChildren(...state.images);
            renderDots();
          }
          state.loaded = true;
        })().catch(() => { loading = null; });
        await loading;
      }
      if (galleries.get(card) === state && state.images.length) show(index);
    }
    controls.addEventListener('click', event => {
      const button = event.target.closest('button');
      if (!button) return;
      event.preventDefault();
      event.stopPropagation();
      move(button.dataset.step ? state.index + Number(button.dataset.step) : Number(button.dataset.slide));
    });
    let start;
    link.style.touchAction = 'pan-y';
    link.addEventListener('touchstart', event => {
      const touch = event.touches[0];
      start = { x: touch.clientX, y: touch.clientY };
    }, { passive: true });
    let suppressClick = false;
    link.addEventListener('touchend', event => {
      if (galleries.get(card) !== state || !start) return;
      const touch = event.changedTouches[0];
      const dx = touch.clientX - start.x;
      const dy = touch.clientY - start.y;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
        suppressClick = true;
        move(state.index + (dx < 0 ? 1 : -1));
        setTimeout(() => { suppressClick = false; }, 400);
      }
      start = null;
    }, { passive: true });
    link.addEventListener('click', event => {
      if (suppressClick) { event.preventDefault(); event.stopPropagation(); }
    });
  }
  const refreshGalleries = () => document.querySelectorAll('.product-card').forEach(setupGallery);
  window.matchMedia('(max-width: 768px)').addEventListener('change', refreshGalleries);
  refreshGalleries();
  new MutationObserver(refreshGalleries).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('click', async event => {
    const option = event.target.closest('.product-card__metal-icon-btn[href]');
    const card = option?.closest('.product-card');
    if (!card) return;
    event.preventDefault();
    event.stopPropagation();
    const url = new URL(option.href, location.href);
    if (url.origin !== location.origin) return;
    const token = {};
    selections.set(card, token);
    card.setAttribute('aria-busy', 'true');
    card.querySelector('.product-card__material-error')?.remove();
    try {
      const endpoint = url.pathname.replace(/\/$/, '') + '.js';
      if (!requests.has(endpoint)) {
        requests.set(endpoint, fetch(endpoint, { headers: { Accept: 'application/json' } })
          .then(response => {
            if (!response.ok) throw new Error('Product unavailable');
            return response.json();
          }).catch(error => { requests.delete(endpoint); throw error; }));
      }
      const product = await requests.get(endpoint);
      if (selections.get(card) !== token || !card.isConnected) return;
      if (!product.id || !product.title) throw new Error('Invalid product');
      const link = card.querySelector('.product-card__image-link');
      const title = card.querySelector('.product-card__title');
      link.href = url.pathname + url.search;
      title.href = link.href;
      title.textContent = product.title;
      link.replaceChildren(...(product.images || []).map((source, index) => {
        const img = document.createElement('img');
        img.className = 'product-card__img product-card__img--' + (index ? 'secondary' : 'primary');
        img.src = typeof source === 'string' ? source : source.src;
        img.alt = product.title;
        img.loading = 'lazy';
        img.decoding = 'async';
        return img;
      }));
      setupGallery(card);
      const currency = card.closest('[data-currency]')?.dataset.currency || window.Shopify?.currency?.active || 'USD';
      const money = value => new Intl.NumberFormat('en-US', {
        style: 'currency', currency, minimumFractionDigits: 0, maximumFractionDigits: 0
      }).format(value / 100);
      card.querySelector('.product-card__price-current').textContent = money(product.price);
      card.querySelector('.product-card__price-compare')?.remove();
      if (product.compare_at_price > product.price) {
        const compare = document.createElement('span');
        compare.className = 'product-card__price-compare';
        compare.textContent = money(product.compare_at_price);
        card.querySelector('.product-card__price').append(compare);
      }
      card.dataset.productId = product.id;
      card.dataset.productHandle = product.handle;
      card.querySelectorAll('.product-card__metal-icon-btn').forEach(button => {
        const active = button === option;
        button.classList.toggle('is-selected', active);
        button.setAttribute('aria-pressed', String(active));
        button.setAttribute('role', 'button');
      });
      card.querySelector('.product-card__badge')?.remove();
      if ((product.tags || []).includes('new')) {
        const badge = document.createElement('span');
        badge.className = 'product-card__badge product-card__badge--accent';
        badge.textContent = 'New';
        card.querySelector('.product-card__media').append(badge);
      }
      const wishlist = card.querySelector('.product-card__wishlist');
      if (wishlist) {
        wishlist.classList.remove('is-active');
        wishlist.setAttribute('aria-pressed', 'false');
        wishlist.setAttribute('aria-label', `Add ${product.title} to wishlist`);
      }
    } catch (error) {
      if (selections.get(card) !== token || !card.isConnected) return;
      const message = document.createElement('span');
      message.className = 'product-card__material-error';
      message.setAttribute('role', 'status');
      message.textContent = 'Unable to load this material. Please try again.';
      card.querySelector('.product-card__material-selection').append(message);
    } finally {
      if (selections.get(card) === token) card.removeAttribute('aria-busy');
    }
  }, true);
  document.addEventListener('keydown', event => {
    if (event.key === ' ' && event.target.matches('.product-card__metal-icon-btn[href]')) {
      event.preventDefault();
      event.target.click();
    }
  });
})();
